import ForgotForm from './ForgotForm';

export default ForgotForm;



// WEBPACK FOOTER //
// ./assets/app/login/components/ForgotForm/index.js